export const STEPS = [
  { id: "owner", label: "مالک" },
  { id: "store", label: "اطلاعات فروشگاه" },
  { id: "template", label: "قالب سایت" },
  { id: "plan", label: "پلن" },
  { id: "payment", label: "پرداخت" },
];

export const PAY_METHODS = [
  {
    id: "card",
    title: "درگاه پرداخت آنلاین",
    sub: "درگاه امن بانکی",
    icon: (
      <>
        <rect x="3" y="6" width="18" height="12" rx="2" />
        <path d="M3 10h18" />
      </>
    ),
  },
  {
    id: "cart-to-cart",
    title: "پرداخت کارت به کارت",
    sub: "واریز به شماره کارت",
    icon: (
      <>
        <path d="M3 7a2 2 0 012-2h13a1 1 0 011 1v3" />
        <path d="M3 7v10a2 2 0 002 2h14a1 1 0 001-1v-7a1 1 0 00-1-1h-4a2 2 0 100 4h5" />
      </>
    ),
  },
];

export const emptyOwner = {
  fullName: "",
  nationalId: "",
  mobile: "",
  email: "",
};

export const emptyStore = {
  storeName: "",
  slug: "",
  province: "",
  city: "",
  category: "",
  landline: "",
  mobile: "",
  address: "",
  logoFile: null,
  imageFile: null,
};
